export const dateType = [
  { id: 'creation', name: 'creation' },
  { id: 'live', name: 'live' },
  { id: 'event', name: 'event' },
  { id: 'expiry', name: 'expiry' },
];

export const offeringPartnerDateType = [
  { id: 'creation', name: 'CREATION' },
  { id: 'expiry', name: 'EXPIRY' },
];

export const membershipMasterDateType = [
  { id: 'update', name: 'UPDATE' },
  { id: 'purchase', name: 'PURCHASE' },
  { id: 'expiry', name: 'EXPIRY' },
];

export const maxDataCount = 20000;
export const maxLogsDataCount = 50000;
export const pageSize_25 = 25;

export const employmentTypeList = [
  { name: 'Academic Institution Employee', value: 'ACADEMIC_INSTITUTION_EMPLOYEE' },
  { name: 'Active Microsoft Employee', value: 'ACTIVE_MICROSOFT_EMPLOYEE' },
  { name: 'Contracted Freelancer', value: 'CONTRACTED_FREELANCER' },
  { name: 'Employed by Learning Partner', value: 'EMPLOYED_BY_LEARNING_PARTNER' },
  { name: 'Freelancer', value: 'FREELANCER' },
  { name: 'Government Employee', value: 'GOVERNMENT_EMPLOYEE' },
  { name: 'Microsoft Partner Employee', value: 'MICROSOFT_PARTNER_EMPLOYEE' },
  { name: 'Other Corporation', value: 'OTHER_CORPORATION' },
];

export const getEmploymentTypeName = (value: string): string => {
  return employmentTypeList.find((type) => type.value === value)?.name || value;
};

export const alumniReasonList = [
  { value: 'FEE', label: 'MCT Fee' },
  { value: 'TRAINING_REQUIREMENTS', label: 'Training Requirements' },
  { value: 'NO_TRAINING_ROLE', label: 'I no longer have a training role' },
  { value: 'OTHER', label: 'Other (please specify)' }
];

export const monthsList = [
  { value: '1', viewValue: 'January' },
  { value: '2', viewValue: 'February' },
  { value: '3', viewValue: 'March' },
  { value: '4', viewValue: 'April' },
  { value: '5', viewValue: 'May' },
  { value: '6', viewValue: 'June' },
  { value: '7', viewValue: 'July' },
  { value: '8', viewValue: 'August' },
  { value: '9', viewValue: 'September' },
  { value: '10', viewValue: 'October' },
  { value: '11', viewValue: 'November' },
  { value: '12', viewValue: 'December' },
];


export const namewithSpace =  /^[\p{L}\p{M}\s'-]+$/u;

export const salutationList = [
  'Mr.',
  'Ms.',
  'Mrs.',
  'Miss',
  'Mx.',
  'Dr.',
  'Prof.',
  'Rev.',
  'Other',
  'Prefer not to specify'
];

export const pronounsList = [
  'He/Him',
  'She/Her',
  'They/Them',
  'He/They',
  'She/They',
  'Use my name',
  'Other / Self-describe',
  'Prefer not to specify'
];

export const solutionAreasList = [
  'Azure',
  'Security',
  'Business Applications',
  'Microsoft 365',
  'Data & AI',
  'Developer Technologies',
  'Infrastructure',
  'Windows / End User Computing',
  'Power Platform',
  'Dynamics 365',
  'Copilot & AI',
  'Fabric / Analytics'
];

export const activeStatusesList = [
  'MVP',
  'OBA (Onboarding Advisor)',
  'Community Lead',
  'MTT',
  'EETS Master Trainer'
];

export const topTechnicalAreasList = [
  'Client Application Development',
  'Cloud + AI',
  'Data + BI',
  'DevOps',
  'IoT',
  'Modern Workspace',
  'Open Source Frameworks',
  'Security + Identity',
  'VR/AR/MR',
  'Other'
];